import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-license-dialog',
  templateUrl: './add-license-dialog.component.html'
})
export class AddLicenseDialogComponent {
  purchaseEmail = 'jack@canadagps.ca';
  productId: 'ntrip-pro'|'ntrip-ent'|'analyzer'|'downloader'|'ntrip-basic'|'analyzer-pro'|'downloader-pro'|'demo' = 'ntrip-pro';
  period: number | null = 1;
  periodType: 'D'|'M'|'Y' | '' = 'M';

  constructor(
    private dialogRef: MatDialogRef<AddLicenseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  cancel(): void { this.dialogRef.close(); }

  create(): void {
    const email = (this.purchaseEmail || '').trim();
    const prod = (this.productId || '').trim();
    const p = Number(this.period);
    const pt = (this.periodType || '').toString().toUpperCase();
    if (!email || !prod || !Number.isFinite(p) || p <= 0 || !['D','M','Y'].includes(pt)) {
      return; // 简单校验，不满足不提交
    }
    this.dialogRef.close({ purchaseEmail: email, productId: prod, period: p, periodType: pt });
  }
}


